// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Fechar',
  error: () => 'Erro',
  warn: () => 'Advertência',
  info: () => 'Informações',
  confirmation: () => 'Confirmação',
  progressIndeterminate: () => 'Em Andamento',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' e ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nenhuma seção correspondente encontrada.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Pressione enter para selecionar um valor.',
  indexer_touchInstructionText: () =>
    'Toque duas vezes e mantenha para entrar no modo de gestos. Em seguida, arraste para cima ou para baixo para ajustar o valor.',
  inputPassword_show: () => 'Mostrar Senha',
  inputPassword_hide: () => 'Ocultar Senha',
  inputPassword_hidden: () => 'Senha Oculta',
  formControl_clear: () => 'Limpar',
  formControl_loading: () => 'Carregando',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Tamanho máximo ' + p['MAX_LENGTH'] + ' excedido.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caracteres restantes.',
  formControl_requiredMessageDetail: () => 'Digite um valor.',
  select_requiredMessageDetail: () => 'Selecione um valor.',
  select_noMatchesFound: () => 'Nenhuma correspondência encontrada.',
  select_oneMatchFound: () => 'Uma correspondência encontrada',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondências encontradas',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' ou mais correspondências encontradas',
  selectMultiple_selectedValues: () => 'Valores selecionados',
  selectMultiple_showSelectedValues: () => 'Mostrar só os valores selecionados.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valores selecionados.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pressione Backspace or Delete para remover o valor selecionado.',
  selectMultiple_apply: () => 'Aplicar',
  selectMultiple_back: () => 'Voltar',
  selector_selected: () => 'Caixa de seleção marcada',
  selector_unselected: () => 'Caixa de seleção não marcada',
  userAssistance_learnMore: () => 'Saiba mais',
  userAssistance_required: () => 'Obrigatório',
  filePicker_singleFileUploadError: () => 'Faz upload um arquivo por vez',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Não é possível fazer upload de arquivos do tipo ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Não é possível fazer upload de arquivos do tipo ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'desconhecido',
  filePicker_dropzonePrimaryText: () => 'Arrastar e Soltar',
  filePicker_dropzoneSecondaryText: () => 'Selecione um arquivo ou solte um aqui',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selecione ou solte arquivos aqui',
  filePicker_addFiles: () => 'Adicionar Arquivos',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Aumentar',
  inputNumber_decrease: () => 'Reduzir',
  inputNumber_converterParseError: () => 'Informe um número.',
  noData_message: () => 'Não há itens para exibição',
  message_navigationFromMessagesRegion: () =>
    'Entrando na área de mensagens. Pressione F6 para navegar de volta ao elemento focado anteriormente.',
  message_navigationToMessagesRegion: () =>
    'A área de mensagens tem novas mensagens. Pressione F6 para navegar até a área de mensagens mais recentes.',
  messageToast_allMessagesClosed: () =>
    'Todas as mensagens de notificação do sistema foram fechadas.',
  expandableList_groupCollapse: () => 'Contraído',
  expandableList_groupExpand: () => 'Expandido',
  expandableList_expandCollapseInstructionText: () =>
    'Use as teclas de seta para expandir e contrair',
  list_suggestion: () => 'Sugestão',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Etapa ' + p['currentStep'] + ' de ' + p['numberOfSteps'],
  train_current: () => 'Atual',
  train_visited: () => 'Visitado',
  train_not_visited: () => 'Não visitado',
  train_message_type: () => 'Tipo de Mensagem',
  viz_drillable: () => 'Disponível para drill',
  dataVisualization_stateSelected: () => 'Selecionado',
  dataVisualization_stateUnselected: () => 'Não Selecionado',
  dataVisualization_noData: () => 'Nenhum dado a ser exibido'
};
export default bundle;
